export const fidoEndPoint = 'Buyer/UWFido';

export const guidField = 'guid';
export const guidOrderField = 'guidOrder';
export const ipAddressField = 'ipAddress';
